export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/updatePassword.js